import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Spin } from 'antd';
import {
  FileTextOutlined,
  QuestionCircleOutlined,
  BookOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { noticiasAPI, perguntasAPI, publicacoesAPI, parceirosAPI } from '../services/api';
import './Dashboard.css';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    noticias: { total: 0, csap: 0, rha: 0 },
    perguntas: { total: 0, csap: 0, rha: 0 },
    publicacoes: { total: 0, csap: 0, rha: 0 },
    parceiros: { total: 0, csap: 0, rha: 0 },
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    setLoading(true);
    try {
      const [noticiasRes, perguntasRes, publicacoesRes, parceirosRes] = await Promise.all([
        noticiasAPI.getAll(),
        perguntasAPI.getAll(),
        publicacoesAPI.getAll(),
        parceirosAPI.getAll(),
      ]);

      const calculateStats = (data) => ({
        total: data.length,
        csap: data.filter(item => item.produto === 'CSAP').length,
        rha: data.filter(item => item.produto === 'RHA').length,
      });

      setStats({
        noticias: calculateStats(noticiasRes.data),
        perguntas: calculateStats(perguntasRes.data),
        publicacoes: calculateStats(publicacoesRes.data),
        parceiros: calculateStats(parceirosRes.data),
      });
    } catch (error) {
      console.error('Erro ao carregar estatísticas:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: 100 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <div className="dashboard-stats">
        <Row gutter={[16, 16]}>          <Col xs={24} sm={12} lg={6}>
            <Card className="dashboard-card">
              <Statistic
                title="Notícias"
                value={stats.noticias.total}
                prefix={<FileTextOutlined />}
                valueStyle={{ display: 'none' }}
              />              <div className="total-container">
                <FileTextOutlined style={{ fontSize: '28px', marginRight: '8px', color: '#1677ff' }}/>
                <span style={{ fontSize: '36px', fontWeight: '700', color: '#333333' }}>{stats.noticias.total}</span>
              </div><div className="dashboard-stats-info">
                <div className="stats-item csap">
                  <span className="stats-label">CSAP</span>
                  <span className="stats-value">{stats.noticias.csap}</span>
                </div>
                <div className="stats-item rha">
                  <span className="stats-label">RHA</span>
                  <span className="stats-value">{stats.noticias.rha}</span>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Card className="dashboard-card">
              <Statistic
                title="Perguntas Frequentes"
                value={stats.perguntas.total}
                prefix={<QuestionCircleOutlined />}
                valueStyle={{ display: 'none' }}
              />              <div className="total-container">
                <QuestionCircleOutlined style={{ fontSize: '28px', marginRight: '8px', color: '#1677ff' }}/>
                <span style={{ fontSize: '36px', fontWeight: '700', color: '#333333' }}>{stats.perguntas.total}</span>
              </div><div className="dashboard-stats-info">
                <div className="stats-item csap">
                  <span className="stats-label">CSAP</span>
                  <span className="stats-value">{stats.perguntas.csap}</span>
                </div>
                <div className="stats-item rha">
                  <span className="stats-label">RHA</span>
                  <span className="stats-value">{stats.perguntas.rha}</span>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Card className="dashboard-card">
              <Statistic
                title="Publicações"
                value={stats.publicacoes.total}
                prefix={<BookOutlined />}
                valueStyle={{ display: 'none' }}
              />              <div className="total-container">
                <BookOutlined style={{ fontSize: '28px', marginRight: '8px', color: '#1677ff' }}/>
                <span style={{ fontSize: '36px', fontWeight: '700', color: '#333333' }}>{stats.publicacoes.total}</span>
              </div><div className="dashboard-stats-info">
                <div className="stats-item csap">
                  <span className="stats-label">CSAP</span>
                  <span className="stats-value">{stats.publicacoes.csap}</span>
                </div>
                <div className="stats-item rha">
                  <span className="stats-label">RHA</span>
                  <span className="stats-value">{stats.publicacoes.rha}</span>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Card className="dashboard-card">
              <Statistic
                title="Parceiros"
                value={stats.parceiros.total}
                prefix={<TeamOutlined />}
                valueStyle={{ display: 'none' }}
              />              <div className="total-container">
                <TeamOutlined style={{ fontSize: '28px', marginRight: '8px', color: '#1677ff' }}/>
                <span style={{ fontSize: '36px', fontWeight: '700', color: '#333333' }}>{stats.parceiros.total}</span>
              </div><div className="dashboard-stats-info">
                <div className="stats-item csap">
                  <span className="stats-label">CSAP</span>
                  <span className="stats-value">{stats.parceiros.csap}</span>
                </div>
                <div className="stats-item rha">
                  <span className="stats-label">RHA</span>
                  <span className="stats-value">{stats.parceiros.rha}</span>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>      <Card title="Informações do Sistema">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <h4>Produtos Disponíveis:</h4>
            <ul className="info-list">
              <li><strong>CSAP</strong> - Cuidados Saúde Atenção Primária</li>
              <li><strong>RHA</strong> - Reprodução Humana Assistida</li>
            </ul>
          </Col>
          <Col xs={24} sm={12}>
            <h4>Recursos do Sistema:</h4>
            <ul className="info-list">
              <li>Gerenciamento de Notícias</li>
              <li>Perguntas Frequentes</li>
              <li>Publicações</li>
              <li>Parceiros</li>
              <li>Upload de Imagens</li>
            </ul>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Dashboard;
